<template>
  <ViewWrapper
    :breadcrumbs="{ title: $t('navigation.SIDEBAR_COMPANY_SETTINGS') }"
  >
    <p class="company-settings-description">
      {{ $t('companySettings.COMPANY_SETTINGS_DESCRIPTION') }}
    </p>

    <BaseTabs
      :key="route.name?.toString()"
      :options="tabItems"
      no-box-container
      :keep-tabs="false"
      :initial-tab-index="activeTabIndex"
      :display-tab-content="false"
      @onSetActiveTab="handleTabChange"
    />
    <div class="company-settings__container">
      <router-view />
    </div>
  </ViewWrapper>
</template>

<script setup lang="ts">
import BaseTabs from '@/components/generics/base/BaseTabs.vue'
import ViewWrapper from '@/components/layout/view_wrapper/ViewWrapper.vue'
import { useI18n } from '@/hooks/useI18N'
import {
  ROUTE_COMPANY_SETTINGS_APPEARANCE,
  ROUTE_COMPANY_SETTINGS_GENERAL,
  ROUTE_COMPANY_SETTINGS_NOTIFICATIONS,
} from '@/router/routes/routeNames'
import { computed } from 'vue'
import { useRoute, useRouter } from 'vue-router/composables'

const i18n = useI18n()
const router = useRouter()
const route = useRoute()

const tabItems = [
  {
    display: i18n.t('companySettings.TAB_GENERAL'),
    value: ROUTE_COMPANY_SETTINGS_GENERAL,
  },
  {
    display: i18n.t('companySettings.TAB_NOTIFICATIONS'),
    value: ROUTE_COMPANY_SETTINGS_NOTIFICATIONS,
  },
  {
    display: i18n.t('companySettings.TAB_ENGAGE'),
    value: ROUTE_COMPANY_SETTINGS_APPEARANCE,
  },
]

const activeTabIndex = computed(() => {
  const index = tabItems.findIndex((tab) => tab.value === route.name)
  return index >= 0 ? index : 0
})

const handleTabChange = ({ value }: { value: string }) => {
  if (value !== route.name) {
    router.push({ name: value })
  }
}
</script>

<style scoped lang="scss">
.company-settings-description {
  color: $color-text-light;
  margin-bottom: $spacing-s;
}

.company-settings__container {
  max-width: $small-desktop-width-max;
}
</style>
